import React, { FC } from 'react'

import { TextPicker } from 'Components'
import { SelectItemType } from 'Components/common/SelectPickerProps'

const renderDateRangeTranslations = (item: SelectItemType): string => {
  switch (item) {
    case '1DAY':
      return '1 Tag'
    case '1WEEK':
      return '1 Woche'
    case '2WEEKS':
      return '2 Wochen'
    case '1MONTH':
      return '1 Monat'
    case '1YEAR':
      return '1 Jahr'
    case 'REGISTRATION':
      return 'Registrierung'
    case 'PROGRAMSTART':
      return 'Programmstart'
    case 'CUSTOM':
      return 'Eigener Zeitraum'
    default:
      return 'n/a'
  }
}

interface Props {
  onChange: (item: SelectItemType) => void
  onItemClick?: (item: SelectItemType) => void
  selectedKey?: number | string
  items: SelectItemType[]
  title?: string
  additionalInfo?: string
  rightOfTitle?: React.ReactNode
  labelOverrides?: Record<string, string>
}

const PanelTextPicker: FC<Props> = ({
  onChange,
  onItemClick,
  items,
  selectedKey,
  children,
  title,
  additionalInfo,
  rightOfTitle,
  labelOverrides
}) => (
  <>
    <div className="row">
      <div className="col-12">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <h1 className="mr-1">{title}</h1>

            {rightOfTitle}
          </div>
          <div>
            <TextPicker
              onChange={onChange}
              onItemClick={onItemClick}
              items={items}
              selectedKey={selectedKey}
              labelExtractor={(item, isSelected) => {
                if (typeof item === 'string' && isSelected && labelOverrides?.[item]) {
                  return labelOverrides[item]
                }

                return renderDateRangeTranslations(item)
              }}
            />
          </div>
        </div>

        {additionalInfo && (
          <div className="mt-1" style={{ position: 'absolute' }}>
            {additionalInfo}
          </div>
        )}
      </div>
    </div>
    <div className="row">{children}</div>
  </>
)

export default PanelTextPicker
